<template>
	<div class="events-wechat">
		<div class="events-wechat__tools" v-show="step=='table'">
			<el-row :gutter="20">
				<el-col :span="14">
					<el-input placeholder="搜索关键词 / 规则名称" v-model="listQuery.searchVal" clearable
						prefix-icon="el-icon-search" size="mini"></el-input>
				</el-col>
				<el-col :span="10">
					<el-button class="search-btn" size="mini" @click="getList()">查 询</el-button>
					<el-button type="primary" size="mini">重 置</el-button>
					<el-button type="primary" size="mini" plain icon="el-icon-plus" @click="onAdd">添 加</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="events-wechat__table" v-show="step=='table'">
			<table-pagination v-loading="loading" ref="tableItem" pagination layout="prev,pager,next,total" :data="data"
				:column="column" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize"
				@pagination="getList">
					<template v-slot:action="{row}">
						<div class="operate-inline">
							<el-button type="text" size="small" @click="onEdit(row)">编辑</el-button>
							<el-divider direction="vertical"></el-divider>
							<el-popconfirm title="确定要删除规则吗？" icon="el-icon-info" @confirm="onDelete(row)">
							   <el-button slot="reference" type="text" size="small">删除</el-button>
							</el-popconfirm>
						</div>
					</template>
			</table-pagination>
		</div>
		<!-- 新增以及编辑 -->
		<setEventsItem ref="setEventsItem" v-if="step=='operate'" @onBack="onBack" :row_subs="row_subs" @getList="getList"></setEventsItem>
	</div>
</template>

<script>
	import setEventsItem from './setEventsItem'
	export default {
		components:{
			setEventsItem
		},
		data(){
			return {
				step:'table',
				loading:false,
				listQuery:{
					searchVal:'',
					pageSize:10,
					pageNum:1
				},
				total:0,
				data:[],
				column:[
					{
						label: '规则名称',
						prop: 'rulename'
					},{
						label: '事件类型',
						prop: 'event'
					},{
						label: '事件关键字',
						prop: 'eventkey'
					},{
						label: '回复内容',
						prop: 'rulesResponseList',
						render:(h,scope)=> {
							return <span>{this.formatValue(scope.row.eventResponseList,'response')}</span>
						}
					},
					{
						label: "操作",
						prop: "action",
						align: "center",
						width: 120,
						fixed:'right',
						slotScope: true,
					}
				],
			}
		},
		props:['row_item'],
		watch:{
			row_item(){
				this.listQuery.pageNum = 1
				this.getList();
			}
		},
		methods:{
			onAdd(){
				this.step = 'operate';
				this.row_subs = ''
			},
			onEdit(row){
				this.step = 'operate';
				this.row_subs = row
			},
			onBack(){
				this.step = 'table'
			},
			onDelete(){},
			formatValue(data,type){
				let results = [];
				if(data){
					data.map(item => {
						results.push(item[type])
					})
				}
				return results.join(',')
			},
			getList(val){
				if(val){
					this.listQuery.pageNum = val.page;
				}
				this.step = 'table';
				let params = {
					 data: {
					    appid: this.row_item.appid || this.row_item.id,
					    searchvalue: this.listQuery.searchVal,
					  },
					  pageNum: this.listQuery.pageNum,
					  pageSize: this.listQuery.pageSize,
				}
				this.$api.getWechatSystemEvent(params).then(res => {
					if(res.errcode == 0) {
						this.data = res.list;
						this.total = res.total
						
					}
				})
			},
		},
		async mounted() {
			await this.getList()
		}
	}
</script>

<style lang="scss" scoped>
	.events-wechat {
		.search-btn {
			color: #337EFF;
			border: 1px solid #337EFF;
		}
	
		&__table {
			margin-top: 20px;
		}
	}
</style>
